module.exports = __webpack_public_path__ + "static/media/background.3cb74cea.svg";